import Doars from './Doars.js'
import { call } from './utilities/Call.js'

Doars.callExpression = call

export default Doars
